export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6783.a085f8fe.jpg";